import ViewsRouter from '@/views/ViewsRouter.vue'
import ViewsSurveySubmitted from '@/views/survey/ViewsSurveySubmitted.vue';
import ViewsSurveyDelivery from '@/views/survey/ViewsSurveyDelivery.vue';
import ViewsSurveyDeliveryFaq from '@/views/survey/ViewsSurveyDeliveryFaq.vue';
import ViewsSurveyCustomer from '@/views/survey/ViewsSurveyCustomer.vue';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/survey',
        name: 'survey-parent',
        component: ViewsRouter,
        children: [
            {
                path: 'submitted',
                name: 'delivery.submitted',
                component: ViewsSurveySubmitted
            },
            {
                path: 'delivery',
                name: 'survey.delivery',
                component: ViewsSurveyDelivery
            },
            {
                path: 'deliveryfaq',
                name: 'survey.deliveryfaq',
                component: ViewsSurveyDeliveryFaq
            },
            {
                path: 'customer',
                name: 'survey.customer',
                component: ViewsSurveyCustomer
            }
        ]
    }
] as RouteRecordRaw[]
